import { Link } from "design-system/components/primitives/link/link";
import { EditAttributes } from "design-system/types/types";

export interface ArticleFooterContributorInfoProps {
  name: string;
  link?: string;
  type?: Array<string>;

  editAttributes?: {
    name?: EditAttributes;
    email?: EditAttributes;
    phone?: EditAttributes;
    type?: EditAttributes;
  };
}

export function ArticleFooterContributorInfo({
  name,
  link,
  editAttributes,
}: ArticleFooterContributorInfoProps) {
  return (
    <address className="hbs-article-footer__author">
      <span {...editAttributes?.name}>
        {link ? <Link href={link}>{name}</Link> : name}
      </span>
    </address>
  );
}
